import SucKhoeHocSinhPage from "./SucKhoeHocSinhPage";
export default SucKhoeHocSinhPage